/**
 * Copyright 2022-2023 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { actions } from '../actionTypes';
import { IUser, getUserinfo } from 'api/auth';

export interface IUserStore {
  CurrentUser?: IUser;
  initialized?: boolean;
}

export const initialUserState: IUserStore = {
  CurrentUser: undefined,
  initialized: false,
};

const user = (state: IUserStore = initialUserState, action): IUserStore => {
  switch (action.type) {
    case actions.SET_CURRENT_USER: {
      return {
        ...state,
        CurrentUser: action.payload.user,
        initialized: true,
      };
    }
    case actions.LOAD_USER_SUCCESS: {
      return {
        ...state,
        CurrentUser: action.payload,
        initialized: true,
      };
    }
    case actions.LOAD_USER_ERROR: {
      return {
        ...state,
        CurrentUser: undefined,
        initialized: true,
      };
    }
    default: {
      return state;
    }
  }
};

export async function fetchUser(dispatch /* , getState */) {
  try {
    const user = await getUserinfo();
    dispatch({ type: actions.LOAD_USER_SUCCESS, payload: user });
  } catch (error) {
    dispatch({ type: actions.LOAD_USER_ERROR, payload: error });
  }
}

export default user;
